import { ORIGIN_IMAGE } from "assets";
import { MISSION_IMAGE } from "assets";
import { Col, Row, Space } from "antd";

import "./styles.scss";

const OurSection = () => {
  return (
    <section className="our-section">
      <div className="our-section-inner container">
        <Space direction="vertical" size={100}>
          {ourSubSections.map((ourSubSection, index) => (
            <Row gutter={[40, 20]} align={"middle"} key={index}>
              <Col xs={24} md={12} order={index % 2 === 0 ? 1 : 2}>
                <h2>{ourSubSection.title}</h2>
                <p
                  className="font-16 line-height-medium text-black-subtle jakarta-sans-font"
                  dangerouslySetInnerHTML={{ __html: ourSubSection.desc }}
                />
              </Col>
              <Col xs={24} md={12} order={index % 2 === 0 ? 2 : 1}>
                <img src={ourSubSection.image} alt="about-us" className="about-pic"/>
              </Col>
            </Row>
          ))}
        </Space>
      </div>
    </section>
  );
};

export default OurSection;

const ourSubSections = [
  {
    title: "Our Origin",
    desc: "The spark that ignited Agape IT came from a simple realization: technology isn’t just about code  and circuits; it’s about people. Our founder,<mark> Neil Ward </mark>, a seasoned tech enthusiast, saw an  opportunity to bridge the gap between cutting-edge solutions and genuine human care. With a  heart full of compassion and a mind buzzing with ideas, Neil set out to build a company that  would redefine the IT landscape.",
    image: ORIGIN_IMAGE,
  },
  {
    title: "Our Mission",
    desc: "Agape IT’s mission is clear: <mark> to empower businesses with technology that resonates with their  core values. </mark> We don’t just write lines of code; we weave narratives that align with your brand’s  purpose. Whether it’s streamlining processes, securing data, or enhancing user experiences, we  do it all with heart.",
    image: MISSION_IMAGE,
  },
];
